import React from "react";
import { Button, Container } from "react-bootstrap";

export const Certification = () => {
  return (
    <>
    <div className="Title">
      <Container>
        <div className="CertificationMain">
          <div className="Certification">
            <h6>~ AFFORDABLE CERTIFICATION</h6>
            <h2>Get Your Quality Skills Certificate Through Online Exam</h2>
            <p>
              Explore all of our courses and pick your suitable ones to enroll
              and start learning with us! We ensure that you will never regret
              it!
            </p>
            <div className="CBtn">
            <Button className="btn-box-common">
            Get Started Now
            </Button>
            </div>
          </div>
        </div>
      </Container>
      </div>
    </>
  );
};
